import React, { useEffect, useId, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../../components/landingPage/Header";
import SideBar from "../../../components/b2b/SideBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fa42Group } from "@fortawesome/free-brands-svg-icons";
import {
  faAdd,
  faListCheck,
  faPlaneUp,
} from "@fortawesome/free-solid-svg-icons";
import { BookingInputField } from "../NewBooking/NewBooking";
import {
  ArrowRightIcon,
  CashIcon,
  LocationMarkerIcon,
  PlusIcon,
  TrashIcon,
  UsersIcon,
} from "@heroicons/react/solid";
import AutoCompletePlaceItem from "../../../components/b2c/AutoCompletePlaceItem";
import GoogleIcon from "../../../assets/icons/google.png";
import moment from "moment";
import DatePicker from "react-date-picker";
import TimePicker from "../../../utils/TimePicker/TimePicker";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  LinearProgress,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  faEnvelope,
  faGlobe,
  faMobile,
  faUser,
  faUserCheck,
} from "@fortawesome/fontawesome-free-solid";
import PassengerDetailInputField from "../../../components/b2c/PassengerDetailInputField";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import { ArrowBack, ArrowBackIos } from "@material-ui/icons";
import { RotateLeft } from "@mui/icons-material";
import { setSourceInput } from "../../../redux/app/map/map-slice";
import axios from "axios";

const TripPackage = () => {
  const { token } = useSelector((state) => state.auth);
  const { allVehicles } = useSelector((state) => state.vehicle);
  const [navOn, setnavOn] = useState(true);
  const [tripCount, settripCount] = useState(0);
  const [tripData, settripData] = useState({});
  const dispatch = useDispatch();
  const [searchFieldId, setsearchFieldId] = useState();
  const [timeValue, setTimeValue] = useState("10:00");

  const [sourceSuggestionOpen, setSourceSuggestionOpen] = useState(false);
  const [destSuggestionOpen, setDestSuggestionOpen] = useState(false);
  console.log("trip data", tripData);

  const {
    sourceInputFromApi,
    sourceInput,
    destinationInput,
    destinationInputFromApi,
    placesbygoogle,
    placesbygoogleForDestination,
    isTripPackageSearchLoading,
    isTripDestPackageSearchLoading,
  } = useSelector((state) => state.map);

  const {
    selectedPassenger,
    timeDetails,
    selectdCurrency,
    sourceLatLan,
    destinationLatLan,
    distanceInKm,
    isSearhingCar,
    sourceWithRegion,
    destinationWithRegion,
    airPorts,
    booking,
  } = useSelector((state) => state.booking);

  let Currency = [
    "USD",
    "INR",
    "EUR",
    "GBP",
    "AUD",
    "CAD",
    "SGD",
    "JPY",
    "AED",
    "CNY",
    "KWD",
    "NZD",
    "QAR",
    "SAR",
    "SGD",
    "OMR",
  ];

  const duration = [
    {
      hour: 1,
      distance: 20,
    },
    {
      hour: 2,
      distance: 40,
    },
    {
      hour: 3,
      distance: 60,
    },
    {
      hour: 4,
      distance: 80,
    },
    {
      hour: 5,
      distance: 100,
    },
    {
      hour: 6,
      distance: 120,
    },
    {
      hour: 7,
      distance: 140,
    },
    {
      hour: 8,
      distance: 160,
    },
    {
      hour: 9,
      distance: 180,
    },
    {
      hour: 10,
      distance: 200,
    },
    {
      hour: 11,
      distance: 220,
    },
    {
      hour: 12,
      distance: 240,
    },
    {
      hour: 13,
      distance: 260,
    },
    {
      hour: 14,
      distance: 280,
    },
    {
      hour: 15,
      distance: 300,
    },
    {
      hour: 16,
      distance: 320,
    },
    {
      hour: 17,
      distance: 340,
    },
    {
      hour: 18,
      distance: 360,
    },
    {
      hour: 19,
      distance: 380,
    },
    {
      hour: 20,
      distance: 400,
    },
    {
      hour: 21,
      distance: 420,
    },
    {
      hour: 22,
      distance: 440,
    },
    {
      hour: 23,
      distance: 460,
    },
    {
      hour: 24,
      distance: 480,
    },
  ];

  // actions
  const getLatLongAction = async (
    placeid,
    tripid,
    placeDescription,
    locationType
  ) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/places/placesDetailsSource?place_id=${placeid}`
    );

    console.log("response", response.data);

    if (locationType === "DESTINATION") {
      settripData({
        ...tripData,
        [tripid]: {
          ...tripData[tripid],
          destination: {
            placename: placeDescription + response?.data?.address,
            placeid: sourceInputFromApi?.place_id,
            lat: response?.data?.result?.lat,
            lng: response?.data?.result?.lng,
          },
          externalData: {
            ...tripData[tripid].externalData,
            destination: placeDescription + response?.data?.address,
            destinationSearchComplete: true,
          },
        },
      });
    } else if (locationType === "SOURCE") {
      settripData({
        ...tripData,
        [tripid]: {
          ...tripData[tripid],
          source: {
            placename: placeDescription + response?.data?.address,
            placeid: sourceInputFromApi?.place_id,
            lat: response?.data?.result?.lat,
            lng: response?.data?.result?.lng,
          },
          externalData: {
            ...tripData[tripid].externalData,
            source: placeDescription + response?.data?.address,
            sourceSearchComplete: true,
          },
        },
      });
    }
  };

  useEffect(() => {
    const getPlacesFromGoogleData = setTimeout(() => {
      if (
        tripData[searchFieldId]?.externalData?.source?.length > 2 &&
        !tripData[searchFieldId]?.externalData?.sourceSearchComplete
      ) {
        dispatch({
          type: "GET_PLACES_FROM_GOOGLE_TRIP_PACKAGE",
          payload: tripData[searchFieldId]?.externalData?.source,
        });
      }
    }, 800);
    return () => clearTimeout(getPlacesFromGoogleData);
  }, [
    tripData[searchFieldId]?.externalData?.source,
    tripData[searchFieldId]?.externalData?.sourceSearchComplete,
  ]);

  useEffect(() => {
    const getPlacesFromGoogleData = setTimeout(() => {
      if (
        tripData[searchFieldId]?.externalData?.destination?.length > 2 &&
        !tripData[searchFieldId]?.externalData?.destinationSearchComplete
      ) {
        dispatch({
          type: "GET_PLACES_FROM_GOOGLE_FOR_DEST_TRIP_PACKAGE",
          payload: tripData[searchFieldId]?.externalData?.destination,
        });
      }
    }, 800);
    return () => clearTimeout(getPlacesFromGoogleData);
  }, [
    tripData[searchFieldId]?.externalData?.destination,
    tripData[searchFieldId]?.externalData?.destinationSearchComplete,
  ]);

  console.log("tripData", tripData);

  return (
    <div className="fixed w-screen scrollbar max-h-full overflow-y-auto">
      <Header token={token} />
      <div className="flex">
        <div className="relative ">
          {navOn && <SideBar />}
          <div
            onClick={() => {
              setnavOn(!navOn);
            }}
            className={`absolute  top-0 bg-red-600 ${
              navOn ? "rotate-0 -right-3" : "rotate-180 -right-7"
            } transition-transform  rounded-full flex justify-end items-center w-7 h-7 cursor-pointer`}
          >
            <ArrowBackIos className=" w-5 h-5 text-white  " />
          </div>
        </div>
        <div className="w-screen ">
          <div className="flex items-center justify-between shadow-md px-11 py-[26px]">
            <div className="text-2xl text-black  ">Trip Details</div>
            {/* <div className="bg-teal-600 rounded-sm hover:bg-teal-700 cursor-pointer text-white px-1 py-1 flex items-center space-x-1">
              <div className="text-sm">Add new trip</div>
              <FontAwesomeIcon icon={faAdd} />
            </div> */}
          </div>

          {/* new trip */}
          <div className="flex  justify-start items-start space-x-1 bg-[#f2f2f2]">
            {/* trip detail */}
            <div className="w-full py-1 px-1">
              <div className="bg-[#F2F2F2] flex items-center justify-between py-2">
                <div className="flex items-center space-x-2 py-1 px-2">
                  <span className="text-stone-500 text-xl font-medium">
                    Total Trips:
                  </span>
                  <span className="text-lg text-secondary font-bold ">
                    {Object.keys(tripData).length}
                  </span>
                </div>

                <div className="flex space-x-2">
                  <button
                    onClick={() => {
                      settripCount(0);

                      settripData({});
                    }}
                    className="bg-secondary cursor-pointer hover:shadow-lg fo w-7 h-7  rounded-full  flex items-center justify-center"
                  >
                    <RotateLeft className=" w-4 h-4   text-white " />
                  </button>
                  <button
                    onClick={() => {
                      settripCount(tripCount + 1);
                      let tripid = tripCount + 1;
                      settripData({
                        ...tripData,
                        [tripid]: {
                          bookingType: "ONEWAY",
                        },
                      });
                    }}
                    className="bg-secondary cursor-pointer hover:shadow-lg fo w-7 h-7  rounded-full  flex items-center justify-center"
                  >
                    <PlusIcon className=" w-4 h-4   text-white " />
                  </button>
                </div>
              </div>
              <div className="overflow-y-auto h-[90vh] ">
                {Object.keys(tripData).map((trip) => {
                  return (
                    <Accordion>
                      <div className="flex px-1">
                        <AccordionSummary
                          className=" w-full"
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1bh-content"
                          id="panel1bh-header"
                        >
                          <div>Trip {trip}</div>
                        </AccordionSummary>
                        <button
                          onClick={() => {
                            delete tripData[trip];
                            settripData({ ...tripData });
                            settripCount(tripCount - 1);
                          }}
                        >
                          <TrashIcon className="w-5 text-red-600" />
                        </button>
                      </div>

                      <AccordionDetails>
                        <div className="w-full border rounded-md py-2 px-2  my-2">
                          <div className="flex items-center space-x-3 py-3 justify-center">
                            <button
                              onClick={() => {
                                settripData({
                                  ...tripData,
                                  [trip]: {
                                    ...tripData[trip],
                                    bookingType: "ONEWAY",
                                  },
                                });
                              }}
                              className={`${
                                tripData[trip].bookingType === "ONEWAY"
                                  ? "bg-secondary text-white"
                                  : "text-black"
                              }  px-2 py-0.5 rounded-sm cursor-pointer`}
                            >
                              Oneway
                            </button>
                            <button
                              onClick={() => {
                                settripData({
                                  ...tripData,
                                  [trip]: {
                                    ...tripData[trip],
                                    bookingType: "HOURLY",
                                  },
                                });
                              }}
                              className={`${
                                tripData[trip].bookingType === "HOURLY"
                                  ? "bg-secondary text-white"
                                  : "text-black"
                              }  px-2 py-0.5 rounded-sm cursor-pointer`}
                            >
                              Hourly
                            </button>
                          </div>
                          <div className="space-y-4   ">
                            <div className="relative">
                              <BookingInputField
                                placeHolder="Address, Hotel, Airport"
                                Icon={LocationMarkerIcon}
                                label="From"
                                type="text"
                                onChange={(e) => {
                                  setSourceSuggestionOpen(true);
                                  setsearchFieldId(trip);
                                  settripData({
                                    ...tripData,
                                    [trip]: {
                                      ...tripData[trip],
                                      externalData: {
                                        ...tripData[trip].externalData,
                                        source: e.target.value,
                                        sourceSearchComplete: false,
                                      },
                                    },
                                  });
                                }}
                                value={tripData[trip]?.externalData?.source}
                              />

                              {isTripPackageSearchLoading ? (
                                <div className="">
                                  <LinearProgress color="error" />
                                </div>
                              ) : (
                                <div className="h-1" />
                              )}
                            </div>

                            {placesbygoogle.length > 0 &&
                              sourceSuggestionOpen && (
                                <>
                                  <div className="bg-slate-100 absolute w-[65%] mx-20 -translate-x-20 h-72 transform scrollbar rounded-bl-md rounded-br-md shadow-2xl z-10">
                                    <div className="overflow-y-auto">
                                      {placesbygoogle?.map((place, index) => (
                                        <>
                                          <AutoCompletePlaceItem
                                            onClick={() => {
                                              // setting source input to input field and to redux store
                                              dispatch(
                                                setSourceInput({
                                                  sourceInputFromApi: place,
                                                })
                                              );

                                              console.log("place----->", place);
                                              // and the same time finding lat an  lng to store to db and to get distance

                                              getLatLongAction(
                                                place.place_id,
                                                trip,
                                                place?.description,
                                                "SOURCE"
                                              );
                                            }}
                                            key={place?.place_id}
                                            placeTerms={place?.terms}
                                          />
                                        </>
                                      ))}
                                    </div>
                                  </div>
                                </>
                              )}

                            <div>
                              <BookingInputField
                                placeHolder="Address, Hotel, Airport"
                                Icon={LocationMarkerIcon}
                                label="To"
                                type="text"
                                onChange={(e) => {
                                  setDestSuggestionOpen(true);
                                  setsearchFieldId(trip);
                                  settripData({
                                    ...tripData,
                                    [trip]: {
                                      ...tripData[trip],
                                      externalData: {
                                        ...tripData[trip].externalData,
                                        destination: e.target.value,
                                        destinationSearchComplete: false,
                                      },
                                    },
                                  });
                                }}
                                value={
                                  tripData[trip]?.externalData?.destination
                                }
                              />
                              {isTripDestPackageSearchLoading ? (
                                <div className="">
                                  <LinearProgress color="error" />
                                </div>
                              ) : (
                                <div className="h-1" />
                              )}
                            </div>

                            {placesbygoogleForDestination.length > 0 &&
                              destSuggestionOpen && (
                                <>
                                  <div className="bg-slate-100 absolute w-[65%] mx-20 -translate-x-20 h-72 transform scrollbar rounded-bl-md rounded-br-md shadow-2xl z-10">
                                    <div className="overflow-y-auto">
                                      {placesbygoogleForDestination?.map(
                                        (place, index) => (
                                          <>
                                            <AutoCompletePlaceItem
                                              onClick={() => {
                                                // setting source input to input field and to redux store
                                                setDestSuggestionOpen(false);

                                                getLatLongAction(
                                                  place.place_id,
                                                  trip,
                                                  place?.description,
                                                  "DESTINATION"
                                                );
                                              }}
                                              key={place?.place_id}
                                              placeTerms={place?.terms}
                                            />
                                          </>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </>
                              )}

                            {/* date */}
                            <div className="w-full offlinebooking">
                              <div className="text-sm font-semibold font-body text-gray-800">
                                Date
                              </div>
                              <DatePicker
                                className="w-24 "
                                format="dd-MM-y"
                                dayPlaceholder="DD"
                                monthPlaceholder="MM"
                                yearPlaceholder="YYYY"
                                // minDate={new Date()}
                                minDate={new Date(moment().subtract(1, "day"))}
                                onChange={(e) => {
                                  //   setDateValue(e);
                                  //   setDateChange(moment(e).format("yyyy-MM-DD"));
                                }}
                                onClick={() => {
                                  //   setOpenCurrency(false);
                                  //   setopenPassengerSelect(false);
                                  //   setSourceSuggestionOpen(false);
                                  //   setDestinationSuggestionOpen(false);
                                  //   setOpenTimePicker(false);
                                  //   setOpenHour(false);
                                }}
                                // value={dateValue}
                              />
                            </div>

                            {/* time */}
                            <div className="relative w-full grow mt-4 md:mt-0">
                              <div className="flex space-x-2">
                                <input
                                  type="time"
                                  value={timeValue}
                                  onClick={() => {
                                    // setOpenTimePicker(true);
                                    // setOpenCurrency(false);
                                    // setopenPassengerSelect(false);
                                    // setSourceSuggestionOpen(false);
                                    // setDestinationSuggestionOpen(false);
                                    // setOpenHour(false);
                                  }}
                                  onChange={(e) => {
                                    // setisTimeChange(true);
                                    // setTimeValue(e.target.value);
                                    // setTimeChange(e.target.value);
                                  }}
                                  // 24 hours format
                                />
                                <ArrowRightIcon className="w-5" />
                                {/* </DemoContainer> */}
                                {/* </LocalizationProvider> */}

                                {/* {openTimePicker && (
                            <div className="absolute translate-y-5 ">
                              <div className="animate__animated animate__fadeIn ">
                                <TimePicker
                                  onHandleTimeChange={handleTimeChange}
                                  onClickClose={() => {
                                    setOpenTimePicker(false);
                                  }}
                                  timeValue={timeValue}
                                />
                              </div>
                            </div>
                          )} */}
                                <div
                                  className="textField  cursor-pointer"
                                  onClick={() => {
                                    // setOpenTimePicker(true);
                                    // setOpenCurrency(false);
                                    // setopenPassengerSelect(false);
                                    // setSourceSuggestionOpen(false);
                                    // setDestinationSuggestionOpen(false);
                                    // setOpenHour(false);
                                  }}
                                >
                                  {timeValue}
                                </div>
                              </div>
                            </div>

                            {/* passenger count */}
                            <div className="w-full grow sm:mb-3">
                              <BookingInputField
                                Icon={UsersIcon}
                                placeHolder="Select passenger"
                                label="Passenger"
                                //   value={selectedPassenger}
                                onClickClear={() => {
                                  // dispatch(clearPassenger());
                                }}
                                onChange={() => {}}
                                onClick={() => {
                                  // setopenPassengerSelect(true);
                                  // setOpenCurrency(false);
                                  // setSourceSuggestionOpen(false);
                                  // setDestinationSuggestionOpen(false);
                                  // setOpenTimePicker(false);
                                  // setOpenHour(false);
                                }}
                              />

                              {/* passenger dropdown start */}
                              {/* {openPassengerSelect && (
                      <>
                        <div className="bg-slate-100 absolute w-auto h-auto mx-20 transform -translate-y-5 -translate-x-20 scrollbar rounded-bl-md rounded-br-md shadow-2xl overflow-y-auto">
                          <div>
                            {passenger.map((passenger) => (
                              <>
                                <div
                                  key={passenger}
                                  onClick={() => {
                                    dispatch(
                                      selectPassenger({
                                        selectedPassenger:
                                          passenger +
                                          ` ${
                                            passenger > 1
                                              ? "Passengers"
                                              : "Passenger"
                                          } `,
                                      })
                                    );
                                    // setopenPassengerSelect(false);
                                  }}
                                  className="flex items-center px-5 py-2 space-x-2 text-[15px] font-normal cursor-pointer hover:bg-secondary hover:text-white"
                                >
                                  <span>{passenger}</span>
                                  <span>
                                    {passenger > 1 ? "Passengers" : "Passenger"}
                                  </span>
                                </div>
                              </>
                            ))}
                          </div>
                        </div>
                      </>
                    )} */}
                            </div>

                            {/* currency */}
                            <div className="w-full grow mt-4 md:mt-0">
                              <BookingInputField
                                Icon={CashIcon}
                                placeHolder="Select Currency"
                                label="Currency"
                                //   value={selectdCurrency}
                                onClickClear={() => {
                                  // dispatch(clearCurrency());
                                }}
                                onChange={() => {}}
                                onClick={() => {
                                  // setOpenCurrency(true);
                                  // setopenPassengerSelect(false);
                                  // setSourceSuggestionOpen(false);
                                  // setDestinationSuggestionOpen(false);
                                  // setOpenTimePicker(false);
                                  // setOpenHour(false);
                                }}
                              />

                              {/* {openCurrency && (
                      <>
                        <div className="bg-slate-100 absolute w-[30%] md:w-[25%] lg:w-[20%] mx-20 h-48 transform -translate-x-20 -translate-y-5  scrollbar rounded-bl-md rounded-br-md shadow-2xl">
                          <div className="overflow-y-auto scrollbar max-h-48">
                            {Currency.map((c, index) => (
                              <>
                                <div
                                  key={index}
                                  onClick={() => {
                                    // dispatch(
                                    //   setCurrency({
                                    //     selectdCurrency: c,
                                    //   })
                                    // );
                                    // setOpenCurrency(false);
                                  }}
                                  className="flex items-center px-3 py-2 space-x-2 text-[15px] font-normal cursor-pointer hover:bg-secondary hover:text-white"
                                >
                                  <span>{c}</span>
                                </div>
                              </>
                            ))}
                          </div>
                        </div>
                      </>
                    )} */}
                            </div>

                            {/* choose vehicle */}
                            <FormControl fullWidth>
                              <InputLabel
                                variant="standard"
                                htmlFor="uncontrolled-native"
                              >
                                Vehicle
                              </InputLabel>
                              <NativeSelect
                                defaultValue={30}
                                inputProps={
                                  {
                                    // name: "age",
                                    // id: "uncontrolled-native",
                                  }
                                }
                              >
                                <option value={10}>
                                  CARAVELLE - ECONOMY VAN/SUV
                                </option>
                                <option value={20}>
                                  ESCALADE - PREMIUM VAN/SUV
                                </option>
                                <option value={30}>
                                  TOYOTA ALPHARD - PREMIUM VAN/SUV
                                </option>
                              </NativeSelect>
                            </FormControl>

                            <div className="flex space-x-5">
                              <div>
                                <div>Currency</div>
                                <input type="text" className="textField" />
                              </div>
                              <div>
                                <div>Price</div>
                                <input type="text" className="textField" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  );
                })}
              </div>
            </div>
            {/* passenger details */}
            <div className="w-full flex-col px-9 py-3 justify-start border rounded-md my-1 h-[80vh] bg-white ">
              <div className="">
                <div className="text-xl shadow-lg bg-stone-100 text-secondary text-center py-1 rounded-full  font-medium  boder-b-2 border-slate-500">
                  Passenger Details
                </div>
                <div className="py-5 space-y-3">
                  <div className="flex space-x-3">
                    <PassengerDetailInputField
                      label="First Name*"
                      inputType="text"
                      icon={faUser}
                      placeHolder="Enter First name"
                      onChange={(e) => {
                        // setPassenger({ ...passenger, firstname: e.target.value });
                      }}
                      onClick={() => {
                        // setopenContryCode(false);
                      }}
                    />
                    <PassengerDetailInputField
                      label="Last Name*"
                      icon={faUser}
                      placeHolder="Enter Last name"
                      onChange={(e) => {
                        // setPassenger({ ...passenger, lastname: e.target.value });
                      }}
                      onClick={() => {
                        // setopenContryCode(false);
                      }}
                    />
                  </div>
                  <PassengerDetailInputField
                    label="Email address*"
                    inputType="email"
                    icon={faEnvelope}
                    placeHolder="Enter Email address"
                    onChange={(e) => {
                      // setPassenger({ ...passenger, email: e.target.value });
                    }}
                    onBlur={() => {
                      // if (passenger.email) {
                      //   if (!validateEmail(passenger.email)) {
                      //     toast.warn("Please enter valid email address");
                      //   }
                      // }
                    }}
                    onClick={() => {
                      // setopenContryCode(false);
                    }}
                  />
                  <div className="flex space-x-2">
                    {/* country code */}
                    <div className="w-52 ">
                      <PassengerDetailInputField
                        className="text-sm py-1 text-gray-700"
                        label="Country & Code*"
                        inputType="text"
                        icon={faGlobe}
                        placeHolder="Select Country and code"
                        //   value={
                        //     passenger.country
                        //       ? passenger.country + "      " + passenger.dial_code
                        //       : searchCountryCode
                        //   }
                        onChange={(e) => {
                          // setsearchCountryCode(e.target.value);
                        }}
                        onFocus={() => {
                          // setopenContryCode(true);
                          // setPassenger({
                          //   ...passenger,
                          //   country: "",
                          //   dial_code: "",
                          // });
                        }}
                        onClick={() => {
                          // setopenContryCode(true);
                          // setPassenger({
                          //   ...passenger,
                          //   country: "",
                          //   dial_code: "",
                          // });
                        }}
                      />
                      {/* <div className="absolute top-[3.6rem]">
                    {openContryCode && (
                      <div className="bg-white translate-y-64 absolute w-52 h-60 overflow-y-auto mx-1 scrollbar rounded-bl-md rounded-br-md border bottom-2 shadow-2xl">
                        {CountryList.map(
                          (country) =>
                            country.name
                              .toLowerCase()
                              .includes(searchCountryCode.toLowerCase()) && (
                              <div
                                onClick={(e) => {
                                  setPassenger({
                                    ...passenger,
                                    country: country.name,
                                    dial_code: country.dial_code,
                                  });
                                  setopenContryCode(false);
                                }}
                                className="flex justify-between space-y-2 px-3 py-2 items-center cursor-pointer hover:bg-secondary hover:text-white text-sm"
                              >
                                <div>{country.name}</div>
                                <div>{country.dial_code}</div>
                              </div>
                            )
                        )}
                      </div>
                    )}
                  </div> */}
                    </div>

                    {/*  */}
                    <div className=" w-52">
                      <PassengerDetailInputField
                        label="Phone Number*"
                        inputType="number"
                        icon={faMobile}
                        placeHolder="Enter Phone Number"
                        onChange={(e) => {
                          //   setPassenger({ ...passenger, phone: e.target.value });
                        }}
                        onClick={() => {
                          //   setopenContryCode(false);
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex space-x-3">
                    <PassengerDetailInputField
                      label="Flight Number"
                      inputType="text"
                      icon={faPlaneUp}
                      placeHolder="Flight/Train Number (Must for Airport/Station Pickup & Dropoff)"
                    />
                    <PassengerDetailInputField
                      label="Reference Number*"
                      inputType="text"
                      icon={faUserCheck}
                      placeHolder="Your referene number(if any) "
                      onChange={(e) => {
                        // setPassenger({ ...passenger, reference: e.target.value });
                      }}
                      onClick={() => {
                        // setopenContryCode(false);
                      }}
                    />
                  </div>
                  <PassengerDetailInputField
                    label="Special Request"
                    inputType="text"
                    icon={faListCheck}
                    placeHolder="Special Request (if any)"
                    onChange={(e) => {
                      // setPassenger({
                      //   ...passenger,
                      //   specialRequest: e.target.value,
                      // });
                    }}
                    onClick={() => {
                      // setopenContryCode(false);
                    }}
                  />
                </div>
                <div className="sm:flex sm:space-x-16 md:flex-col lg:space-x-10 lg:flex-row space-x-0 md:space-x-0 justify-between">
                  <div className="flex space-x-2 text-sm items-center">
                    <input
                      type="checkbox"
                      className="cursor-pointer"
                      onClick={(e) => {
                        // setisPassengerDetailCheck(e.target.checked);
                        // setopenContryCode(false);
                      }}
                    />
                    <div>
                      I agree to{" "}
                      <span className="text-primary text-sm">
                        <a
                          href="www.google.com"
                          alt=""
                          className="text-secondary hover:underline"
                        >
                          Terms & Conditions
                        </a>
                        ,{" "}
                        <a
                          href="www.google.com"
                          alt=""
                          className="text-secondary hover:underline"
                        >
                          Booking Conditions
                        </a>{" "}
                        and{" "}
                        <a
                          href="www.google.com"
                          alt=""
                          className="text-secondary hover:underline"
                        >
                          Privacy Policy
                        </a>
                        .
                      </span>{" "}
                    </div>
                  </div>
                  <button
                    // onClick={confirmBookingHandler}
                    className="w-52 h-10 text-white text-base rounded-md hover:bg-red-700 bg-secondary px-1  "
                  >
                    Create Trips
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TripPackage;
